import { AfterContentInit, Component, Input, OnChanges } from '@angular/core'
import { Observable } from 'rxjs'
import { CurrencyAmount, CurrencyAmountType } from '../../../../../graphql'
import { CurrencyService } from '../../../../injectable/currency-service'

/**
 * TODO - This component as well as CurrencyTypeComponent are hardly used
 *        and makes little sense in general.
 *        Definite candidates to be deprecated.
 */
@Component({
    selector: 'app-currency-amount',
    templateUrl: 'currency-amount.html'
})
export class CurrencyAmountComponent implements AfterContentInit, OnChanges {
    @Input() currency: string | undefined
    @Input() currencyAmountType: CurrencyAmountType
    convertedCurrency$: Observable<CurrencyAmount>

    constructor(
        private _currencyService: CurrencyService
    ) {
    }

    // Public
    ngAfterContentInit() {
        this.convertedCurrency$ = this._currencyService.convertToPresentmentCurrency(this.currencyAmountType)
    }

    ngOnChanges() {
        // TODO - revisit
        // Converted fees where not updating when @input current changed.
        // This has fixed it but not sure it is the best way to do it.
        this.convertedCurrency$ = this._currencyService.convertToPresentmentCurrency(this.currencyAmountType) 
    }
}
